import { Card } from "components/atoms/Card"
import { CardItem } from "components/atoms/CardItem"
import { Empty } from "components/atoms/Empty"
import { useMemo } from "react"
import { LeadProfileDTO } from "utils/dtos/leadDTO"
import EntryFormatter from "utils/EntryFormatter"
import { emptyMessages } from "utils/message"
import pageDetails from "utils/pageDetails"

export const Conversions: React.FC<{ lead: LeadProfileDTO }> = ({ lead }: any) => {
    const preparedData = useMemo(() => {
        return Object.keys(JSON.parse(lead.formData)).map((key) =>
            ({ key: EntryFormatter.firstLetterUppercase(key), value: JSON.parse(lead.formData)[key] })
        )
    }, [lead])
    const isEmptyData = useMemo(() => {
        return preparedData.length === 0
    }, [preparedData])

    return <Card title={EntryFormatter.firstLetterUppercase(pageDetails.pixelConversion.title)} className="overflow-y-auto h-full max-h-fit">
        {isEmptyData ? <Empty message={emptyMessages.conversions} /> : preparedData.map((item, index) => <CardItem key={index} prefix={item.key} value={item.value} borderBottom/>)}
    </Card>
}
